var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var CardContent = styled.div.attrs({
    'data-card-name': 'CardContent'
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  grid-area: content;\n  padding: 1rem 1rem 0 1rem;\n  display: grid;\n  gap: 0.25rem;\n  grid-auto-rows: min-content;\n  p {\n    margin-bottom: 0.25rem;\n  }\n"], ["\n  height: 100%;\n  grid-area: content;\n  padding: 1rem 1rem 0 1rem;\n  display: grid;\n  gap: 0.25rem;\n  grid-auto-rows: min-content;\n  p {\n    margin-bottom: 0.25rem;\n  }\n"])));
export default CardContent;
var templateObject_1;
//# sourceMappingURL=CardContent.js.map